module.exports = __webpack_public_path__ + "img/messaggio-base-alertmsg.199870e6.png";